export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'

export const updateSettings = settings => ({
  type: UPDATE_SETTINGS,
  payload: settings
})


// WEBPACK FOOTER //
// ./src/actions/menu.js